import { isLive } from 'utils/common';

export const SQUARE_SCRIPT_URL = isLive()
    ? 'https://web.squarecdn.com/v1/square.js'
    : 'https://sandbox.web.squarecdn.com/v1/square.js';
